export default [
  {
    path: '/management',
    component: () => import('@/components/Layer.vue'),
    children: [
      {
        path: '/accountManagement/',
        name: 'accountManagement',
        component: () => import('@/views/Management/AccountManagement.vue'),
        children: [
          {
            path: '',
            redirect: { name: 'accountList' }
          },
          {
            path: 'accountList',
            name: 'accountList',
            component: () => import('@/views/Management/AccountList.vue'),
            meta: {
              prev: 'goHome'
            }
          },
          {
            path: 'accountRecord',
            name: 'accountRecord',
            component: () => import('@/views/Management/AccountRecord.vue'),
            meta: {
              prev: 'goHome'
            }
          }
        ]
      },
      {
        path: '/accountSetting/',
        name: 'accountSetting',
        component: () => import('@/views/Management/AccountSetting.vue'),
        children: [
          {
            path: '',
            redirect: { name: 'changeInfo' }
          },
          {
            path: 'changeInfo',
            name: 'changeInfo',
            component: () => import('@/views/Management/ChangeInfo.vue'),
            meta: {
              prev: 'goHome'
            }
          },
          {
            path: 'changePassword',
            name: 'changePassword',
            component: () => import('@/views/Management/ChangePassword.vue'),
            meta: {
              prev: 'goHome'
            }
          }
        ]
      }
    ]
  }
]
